import { formatApiError } from '@/services/api/apiHelpers';

export default function ApiStatusMessage({ loading, error, success, successMsg, loadingMsg }) {
  if (loading)
    return <div style={{ color: '#888', marginTop: 16 }}>{loadingMsg || 'Loading...'}</div>;
  if (error)
    return <div style={{ color: 'red', marginTop: 16 }}>Error: {formatApiError(error)}</div>;
  if (success)
    return <div style={{ color: 'green', marginTop: 16 }}>{successMsg || 'Success!'}</div>;
  return null;
}
